import { PROVINCE_OPTIONS, type Province } from "./provinces";

/**
 * The centrally-managed cities ("Thành phố" — e.g. TP. Hồ Chí Minh, Hà Nội,
 * Đà Nẵng …), as opposed to the provinces ("Tỉnh"). Derived from the dataset's
 * `isCity` flag, in the catalogue's (English-name) order.
 */
export const CITY_PROVINCES: readonly Province[] = PROVINCE_OPTIONS.filter((p) => p.isCity);

export const CITY_SLUGS: ReadonlySet<string> = new Set(CITY_PROVINCES.map((p) => p.slug));

/**
 * True when a DIACRITIC-NORMALISED, lowercased query means "city" in Vietnamese
 * — "TP", "TP." or "Thành phố" (→ "thanh pho"). Used so a search that starts
 * with these surfaces ALL cities as options (most people reach for the city
 * abbreviation). Gated from "thanh p" onward so it never hijacks "thanh" /
 * "Thanh Hoa" (a province); "tp"/"tp." are unambiguous since no province
 * romanises to start with "tp".
 */
export function isCityKeyword(normalised: string): boolean {
  const q = normalised.trim();
  if (q === "tp" || q === "tp.") return true;
  return q.length >= 7 && "thanh pho".startsWith(q);
}
